/** The Update Job action element; fields with a Job counterpart read the Job metadata, the public API's aliases are described inline. */
import { MetadataEntityFieldEditorType, MetadataEntityFieldType } from '../../../metadata/entity/decorators/model/metadata.entity.field.types';
import { ActivityEntityName } from '../../shared/activity.entity.name';
import { WorkflowActionType } from '../workflow.definition';
import { WorkflowElement, WorkflowFamily, WorkflowFieldRenderer, WorkflowSideEffect } from '../workflow.element';

/** Sets the given fields on the run's Job and leaves the rest untouched. */
export const UPDATE_JOB_ELEMENT: WorkflowElement = {
    type: WorkflowActionType.UpdateJob,
    family: WorkflowFamily.Job,
    sideEffect: WorkflowSideEffect.TriggerVisible,
    title: 'Update the Job',
    icon: 'fa-pen-to-square',
    fields: [
        {
            bind: 'input.name',
            entity: ActivityEntityName.Job,
            field: 'name',
            metadata: { displayName: 'Name' },
        },
        {
            // The public API reports `notes` from the Job's `additionalNote`, which has no uiFields metadata.
            bind: 'input.notes',
            renderer: WorkflowFieldRenderer.MergeText,
            metadata: {
                displayName: 'Notes',
                type: MetadataEntityFieldType.String,
                editor: MetadataEntityFieldEditorType.TextArea,
            },
        },
        {
            // The public API reports `reference` from the Job's `customerWO`; it is a public API alias, not a Job uiField.
            bind: 'input.reference',
            metadata: {
                displayName: 'Reference',
                type: MetadataEntityFieldType.String,
            },
        },
        {
            bind: 'input.customerWO',
            entity: ActivityEntityName.Job,
            field: 'customerWO',
        },
        {
            bind: 'input.customerPO',
            entity: ActivityEntityName.Job,
            field: 'customerPO',
        },
        {
            // The public API's `ownerId`; the Job's Owner field picks from Job Owner, which includes subcontractor logins.
            bind: 'input.ownerId',
            entity: ActivityEntityName.Job,
            field: 'owner',
            metadata: { displayName: 'Owner' },
        },
        {
            bind: 'input.fieldSupervisorId',
            entity: ActivityEntityName.Job,
            field: 'fieldSupervisor',
            metadata: { displayName: 'Field supervisor' },
        },
        {
            // Sent as the public API's `tags.add`; labels already on the Job stay. `arrayOf` tells the validator it takes a list.
            bind: 'input.addLabels',
            entity: ActivityEntityName.Job,
            field: 'labels',
            metadata: { displayName: 'Add labels', arrayOf: MetadataEntityFieldType.Tag },
        },
        {
            // Sent as the public API's `tags.remove`.
            bind: 'input.removeLabels',
            entity: ActivityEntityName.Job,
            field: 'labels',
            metadata: { displayName: 'Remove labels', arrayOf: MetadataEntityFieldType.Tag },
        },
    ],
    outputs: [
        { path: 'jobId', metadata: { displayName: 'Job ID', type: MetadataEntityFieldType.String } },
    ],
};
